export default "__VITE_ASSET__e6fe5d62__"